import type { CurrentUser, LoginRequest } from "@iso27001/shared";
import { apiFetch } from "./client.js";

export const authApi = {
  login: (body: LoginRequest) =>
    apiFetch<{ user: CurrentUser }>("/api/auth/login", { method: "POST", body: JSON.stringify(body) }),
  me: () => apiFetch<CurrentUser>("/api/auth/me"),
  logout: () => apiFetch<null>("/api/auth/logout", { method: "POST" }),
};
